<template>
    <MainPage pageTitle="ประวัติการเคลม" :bgClass="isNoData ? 'bg-white' : 'bg-a-gray-efefef'" v-if="isLoaded">
        <template v-if="isNoData">
            <NoDataClaim />
        </template>
        <template v-else>
            <ClaimList :items="items" />
        </template>
    </MainPage>
</template>

<script>
import { defineComponent } from 'vue';

// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import NoDataClaim from '../component/Claim/NoDataClaim.vue';
import ClaimList from '../component/Claim/ClaimList.vue';
import Policyservice from '../../PolicyListing/service/PolicyService';
import { useTracking } from "@/feature/TrackingFeature";
import CacheHelper from "@/helper/CacheHelper.js";

export default defineComponent({
    components: {
        MainPage,
        NoDataClaim,
        ClaimList
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            isLoaded: false,
            isNodata: false,
        }
    },
    created: function() {
        this.tracking.screenName('claim_history')
        this.tracking.event("claim_history_page", "view_claim_history", "", "");

        this.getClaim();
    },
    methods: {
        getClaim: function() {
            this.cache = new CacheHelper('local')
            this.policyId = this.cache.getCache('policyId')
            return new Promise((resolve) => {
                Policyservice.apiGetClaim(this.policyId).subscribe({
                    next: (data) => {
                        // console.log(data)
                        this.items = data
                        this.isLoaded = true
                        this.isNoData = false
                        resolve();
                    },
                    error: (err) => {
                        console.log(err);
                        this.isLoaded = true
                        this.isNoData = true
                        resolve();
                    },
                });
            });
        },
    }
})
</script>
